export default "__VITE_ASSET__1ca92ad0__"